import React from "react";
import classes from "./userTextMessage.module.scss";

function Index(props) {
    const {message, imgSrc} = props;
    return (
        <div className={classes.mainContainer}>
            <img className={`${classes.userImg} userMessage`} src={imgSrc} alt="userImg"/>
            <div className={`${classes.messageContainer} messageContainer`}>
                <p>{message}</p>
            </div>
        </div>
    );
}

export default Index;
